// 푸터 메뉴를 상단 메뉴와 같은 표로 맞춘다.
//
// 퍼블리싱의 푸터는 글자만 얹힌 <p> 6개다(회사소개 / 실시간 거래 시세 / 미디어 허브 /
// 중매거래 / 서비스 이용약관 / 개인정보처리방침). 링크가 없고 상단 메뉴와 이름도 달라,
// 같은 자리를 누가 보느냐에 따라 다른 메뉴가 보였다.
// 이 함수가 그 자리를 SITE_MENU 로 다시 채운다 — 글꼴·색·간격은 퍼블리싱 그대로 두고
// 글자와 링크만 갈아 끼운다.
//
// 약관·개인정보처리방침은 회원과 결제가 있는 자사몰에만 둔다(FOOTER_LEGAL).
// 홈페이지와 미디어 허브는 가입도 결제도 없어 걸 만한 약관이 없다.
//
// ★ 이 파일은 세 저장소에 "복사"해서 쓴다.
//     homepage / goldnaramall-client / mediahub-client
//   고칠 때는 세 곳을 모두 같이 고칠 것.
import { SITE_MENU } from '@/data/siteMenu.js'

// 자사몰 전용. 같은 앱 안의 화면이라 라우터로 넘긴다(to).
//
// 개인정보처리방침은 strong 으로 둔다. 다른 고지사항에 섞여 묻히지 않게
// 구분해서 보여야 한다(개인정보위 안내 · 국내 사이트 관행).
export const FOOTER_LEGAL = [
  { key: 'terms', label: '서비스 이용약관', to: '/terms' },
  { key: 'privacy', label: '개인정보처리방침', to: '/privacy', strong: true },
]

// strong 항목 색. 상단 메뉴가 현재 화면을 표시할 때 쓰는 금색과 같다(2026-09-28).
// 푸터 배경은 어둡다(퍼블리싱 #252525 · 자사몰 검정). 대비 6.9:1 이라 또렷하다.
// 자사몰의 두 푸터(AppFooter · MallFooter)는 이 파일을 안 거쳐서 각자 같은 값을 박아 둔다.
const STRONG_COLOR = '#c4890b'

// 모바일에서 줄이 넘칠 때 줄 사이 간격.
// 퍼블리싱은 20px 글줄 두 줄을 top 96 / 128 에 놓았고 그 아래 173 에 구분선이 있다.
// 8px 이면 두 줄은 96~144, 세 줄이어도 96~172 라 구분선을 건드리지 않는다.
const ROW_GAP = '8px'

/**
 * @param {Element|null} root            캔버스 루트(data-node-id 로 찾을 범위)
 * @param {string[]} containerIds        퍼블리싱의 메뉴 줄 상자. 모바일은 두 줄이라 두 개.
 * @param {object} [options]
 * @param {Array} [options.links]        넣을 메뉴. 기본은 상단 메뉴와 같은 SITE_MENU.
 * @param {number} [options.width]       모바일처럼 폭이 정해진 경우 그 폭(px). 넘치면 다음 줄로 흐른다.
 * @param {(to: string) => void} [options.onNavigate]  to 항목을 눌렀을 때(자사몰 라우터).
 * @param {string} [options.strongColor]  strong 항목 색. 배경이 밝은 푸터에서 바꿔 쓴다.
 */
export function applySiteFooter(root, containerIds, options = {}) {
  if (!root) return
  const { links = SITE_MENU, width = 0, onNavigate = null, strongColor = STRONG_COLOR } = options

  const boxes = containerIds
    .map((id) => root.querySelector(`[data-node-id="${id}"]`))
    .filter(Boolean)
  const box = boxes[0]
  if (!box) return

  // 항목 하나를 본으로 삼아 클래스를 그대로 물려받는다.
  const cls = box.querySelector('p')?.className ?? 'relative shrink-0'

  // 둘째 줄부터는 첫 상자 하나로 합친다. 몇 줄이 될지는 글자 길이에 달렸다.
  boxes.slice(1).forEach((el) => {
    el.style.display = 'none'
  })

  box.replaceChildren(
    ...links.map((item) => {
      const a = document.createElement('a')
      a.className = cls
      a.href = item.to ?? item.href
      a.textContent = item.label
      if (item.strong) {
        a.style.color = strongColor
        a.style.fontWeight = '700'
      }
      if (item.to && onNavigate) {
        a.addEventListener('click', (e) => {
          e.preventDefault()
          onNavigate(item.to)
        })
      }
      return a
    }),
  )

  if (width) {
    box.style.width = `${width}px`
    box.style.flexWrap = 'wrap'
    box.style.rowGap = ROW_GAP
  }
}

// 모바일 푸터의 메뉴 줄 폭. 좌우 15px 여백을 뺀 값이고 구분선(w-[345px])과 같다.
export const MOBILE_FOOTER_WIDTH = 345
